import { AlphaMBoxIcon } from './AlphaMBoxIcon';

/**
 * author: GreenTurtwig
 * id AB678336-D11A-4426-92A8-AA520A4F282B
 * name alpha-m-box
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-m-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterMBoxIcon = AlphaMBoxIcon;
export default LetterMBoxIcon